var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548 115",
    style: {
      enableBackground: "new 0 0 548 115"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#009395;}\r\n\t.st1{font-family:'Calibri-BoldItalic';}\r\n\t.st2{font-size:71.8676px;}\r\n\t.st3{fill:#E22128;}\r\n\t.st4{fill:#D83927;}\r\n\t.st5{font-family:'Calibri';}\r\n\t.st6{font-size:27.3478px;}\r\n\t.st7{fill:none;stroke:#009395;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 0.9 127.4072 75.1062)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st1 st2"
  }, "Speed"), /*#__PURE__*/React.createElement("tspan", {
    x: 179.9,
    y: 0,
    className: "st3 st1 st2"
  }, "Express"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 0.8 171.3452 102.0232)",
    className: "st4 st5 st6"
  }, "tours &amp; travel LLC"), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 374.1,
    y1: 96.5,
    x2: 529.5,
    y2: 96.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,41.8c0,0,1.7,4.8-39.8,24.2C67.8,66,108.5,45.3,107.6,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.6,37.7l0.5,1.8c0,0,2.2-0.7,2.6-1.6C105.7,37.9,105.1,36.8,102.6,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.4,40.9c0,0-4.9,7.8-49.5,27.6C57.9,68.5,106.7,43,107.4,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.6,39.1c0.1,0.3,0,0.6-0.2,0.7L98.7,40c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C99.2,38.6,99.5,38.8,99.6,39.1L99.6,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.4,40c0.1,0.3,0,0.6-0.2,0.7l-0.8,0.2c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C97,39.5,97.3,39.7,97.4,40L97.4,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.2,40.8c0.1,0.3,0,0.6-0.2,0.7l-0.8,0.2c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C94.8,40.3,95.1,40.5,95.2,40.8L95.2,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.9,41.7c0.1,0.3,0,0.6-0.2,0.7L92,42.6c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C92.6,41.2,92.8,41.4,92.9,41.7L92.9,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.7,42.5c0.1,0.3,0,0.6-0.2,0.7l-0.8,0.2c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C90.4,42,90.6,42.2,90.7,42.5L90.7,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.5,43.4c0.1,0.3,0,0.6-0.2,0.7l-0.8,0.2c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C88.1,42.9,88.4,43,88.5,43.4L88.5,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.3,44.2c0.1,0.3,0,0.6-0.2,0.7l-0.8,0.2c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C85.9,43.7,86.2,43.9,86.3,44.2L86.3,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.9,45.2c0.1,0.3,0,0.6-0.2,0.7L83,46.1c-0.2,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0-0.6,0.2-0.7l0.8-0.2 C83.6,44.7,83.8,44.9,83.9,45.2L83.9,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.8,69.7l23.3-14.5L29.3,20.4l5.8-1.4l44.2,26.4c0,0,5.7-3.1,11.9-5.3L57,7.1H7.8L37.8,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,75.1c0,0,20.9-6.1,25.7-8.2l6.2,39.6H55L40,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.5,105.8L86.6,60c0,0,30.1-12.7,27-22.6c0,0,4.5,6.1-9.4,14.2l41.7,42.5c0,0,2.2,6.4-5.6,11.7H78.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/Banner.127a5396d3d43440b92d825a933baddb.svg";
export { ForwardRef as ReactComponent };